import { Spacer, Tab, TabGroup, TabPanel } from '@pypestream/design-system';
import {
  TranslationComponent,
  TranslationKeys,
} from '@pypestream/translations';
import { FC } from 'react';

import { useNavigate } from 'react-router';
import {
  Environments,
  ProjectEnvironmentsType,
  ReturnFormType,
} from '../../../../components';
import { useManagerCtxSelector } from '../../../../xstate/app.xstate';
import { EnvironmentPanel } from './environment-panel';

import { getEnvironmentName } from '../../../../utils';
import './environments.scss';

interface ProjectSettingsEnvironmentsTabProps {
  form: ReturnFormType;
  accountId?: string;
  projectId: string;
  projectEnvironments: ProjectEnvironmentsType;
  disabled?: boolean;
  environmentId?: string;
}

export const ProjectSettingsEnvironmentsTab: FC<
  ProjectSettingsEnvironmentsTabProps
> = ({
  form,
  accountId,
  projectId,
  disabled,
  environmentId,
  projectEnvironments,
}) => {
  const navigate = useNavigate();

  const { routes } = useManagerCtxSelector((ctx) => {
    return {
      routes: ctx.routes,
    };
  });

  return (
    <>
      <TabGroup placement="top-right">
        {projectEnvironments?.flatMap((channel, index) => {
          return (
            <Tab
              key={index}
              slot="tab"
              panel={channel.name}
              active={channel?.id === environmentId}
              type={
                channel?.name === Environments.Testing
                  ? 'staging'
                  : channel?.name === Environments.Production
                    ? 'prod'
                    : 'dev'
              }
              onClick={() => {
                navigate(
                  `${routes.projects}/${projectId}/environments/${channel?.id}`,
                  { replace: true }
                );
              }}
            >
              <TranslationComponent
                i18nKey={
                  `manager/projects:environments.${getEnvironmentName(channel?.name)}` as TranslationKeys
                }
              >
                {channel?.name}
              </TranslationComponent>
            </Tab>
          );
        })}
        {projectEnvironments?.flatMap((channel, index) => {
          return (
            <TabPanel key={index} name={channel.name}>
              <EnvironmentPanel
                form={form}
                environment={channel}
                projectId={projectId}
                environmentIndex={index}
                disabled={disabled}
                accountId={accountId}
              />
            </TabPanel>
          );
        })}
      </TabGroup>
      <Spacer size="2xlarge" />
    </>
  );
};
